import { render, staticRenderFns } from "./urbanDeliverySuppliers.vue?vue&type=template&id=5565162a&"
import script from "./urbanDeliverySuppliers.vue?vue&type=script&lang=js&"
export * from "./urbanDeliverySuppliers.vue?vue&type=script&lang=js&"
import style0 from "./urbanDeliverySuppliers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports